import React from 'react';
import { motion } from 'framer-motion';
import { 
  skillsData, 
  skillCategories, 
  getSkillsByCategory,
  additionalSkillsData,
  additionalSkillCategories,
  getAdditionalSkillsByCategory
} from '../data/skills';
import './Skills.css';
import { useLanguage } from '../i18n';

const Skills = () => {
  const { t } = useLanguage();

  return (
    <section id="skills" className="skills">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>{t('skills.title')}</h2>
          <div className="section-divider"></div>
          <p>{t('skills.subtitle')}</p>
        </motion.div>

        <div className="skills-content">
          {/* Card Principal - Habilidades Técnicas */}
          <motion.div
            className="skills-table-container"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="skills-table">
              {skillCategories.map((category, categoryIndex) => {
                const categorySkills = getSkillsByCategory(category.id);
                
                return (
                  <motion.div
                    key={category.id}
                    className="skills-row"
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: categoryIndex * 0.1 }}
                  >
                    <div className="category-header">
                      <h3 className="category-title">{category.label}</h3>
                    </div>
                    <div className="skills-row-content">
                      {categorySkills.map((skill, skillIndex) => (
                        <motion.div
                          key={skill.name}
                          className="skill-card"
                          initial={{ opacity: 0, scale: 0.8 }}
                          whileInView={{ opacity: 1, scale: 1 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.4, delay: skillIndex * 0.1 }}
                          whileHover={{ scale: 1.05, y: -3 }}
                        >
                          <div className="skill-icon" style={{ color: skill.color }}>
                            {skill.icon}
                          </div>
                          <span className="skill-name">{skill.name}</span>
                          <div className="skill-level">
                            <motion.div
                              className="skill-progress"
                              initial={{ width: 0 }}
                              whileInView={{ width: `${skill.level}%` }}
                              viewport={{ once: true }}
                              transition={{ duration: 1, delay: 0.5 }}
                              style={{ backgroundColor: skill.color }}
                            />
                          </div>
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>

          {/* Card Adicional - Arquitetura e Idiomas */}
          <motion.div
            className="additional-skills-container"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <div className="additional-skills-table">
              {additionalSkillCategories.map((category, categoryIndex) => {
                const categorySkills = getAdditionalSkillsByCategory(category.id);
                
                return (
                  <motion.div
                    key={category.id}
                    className="additional-skills-row"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: categoryIndex * 0.1 }}
                  >
                    <div className="additional-category-header">
                      <h3 className="additional-category-title">{category.label}</h3>
                    </div>
                    <div className="additional-skills-content">
                      {categorySkills.map((skill, skillIndex) => (
                        <motion.div
                          key={skill.name}
                          className="additional-skill-card"
                          initial={{ opacity: 0, scale: 0.8 }}
                          whileInView={{ opacity: 1, scale: 1 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.4, delay: skillIndex * 0.1 }}
                          whileHover={{ scale: 1.05, y: -3 }}
                        >
                          <div className="additional-skill-icon" style={{ color: skill.color }}>
                            {skill.icon}
                          </div>
                          <span className="additional-skill-name">{skill.name}</span>
                          <div className="additional-skill-level">
                            <motion.div
                              className="additional-skill-progress"
                              initial={{ width: 0 }}
                              whileInView={{ width: `${skill.level}%` }}
                              viewport={{ once: true }}
                              transition={{ duration: 1, delay: 0.7 }}
                              style={{ backgroundColor: skill.color }}
                            />
                          </div>
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Skills;